import { SEO } from "@/components/SEO";
import { PageHero } from "@/components/shared";

export default function Terms() {
  return (
    <>
      <SEO title="Website Terms | BJRC" description="Terms of use for the Brackenfell Junior Rugby Club website." />
      <PageHero title="Website Terms" />
      <section className="mx-auto max-w-3xl space-y-5 px-4 py-14 text-slate-700 sm:px-6 lg:px-8">
        <p>By using the Brackenfell Junior Rugby Club website, you agree to these terms.</p>
        <h2 className="font-heading text-xl font-bold uppercase text-[#0B2A4A]">Content</h2>
        <p>Content on this website is provided for general information about the club. While we strive for accuracy, details such as age groups, coaching staff and events may change.</p>
        <h2 className="font-heading text-xl font-bold uppercase text-[#0B2A4A]">Intellectual Property</h2>
        <p>The BJRC name, logo and website content are the property of the club and may not be reproduced without permission.</p>
        <h2 className="font-heading text-xl font-bold uppercase text-[#0B2A4A]">Enquiries</h2>
        <p>Submitting an enquiry does not constitute registration or guarantee a place in any team. A club administrator will respond to confirm next steps.</p>
        <h2 className="font-heading text-xl font-bold uppercase text-[#0B2A4A]">External Links</h2>
        <p>Links to sponsor or third-party websites are provided for convenience. BJRC is not responsible for the content of external sites.</p>
      </section>
    </>
  );
}
